import tags from '../tags';

const {
  passives: {
    offensivePassive,
    defensivePassive,
    resourcePassive,
    mobilityPassive,
    healingPassive,
    cooldownPassive,
  },
} = tags;

export default [
  {
    name: 'Pound of Flesh',
    tags: [healingPassive, mobilityPassive],
  },
  {
    name: 'Ruthless',
    tags: [offensivePassive],
  },
  {
    name: 'Nerves of Steel',
    tags: [defensivePassive],
  },
  {
    name: 'Weapons Master',
    tags: [offensivePassive, resourcePassive],
  },
  {
    name: 'Inspiring Presence',
    tags: [healingPassive],
  },
  {
    name: 'Berserker Rage',
    tags: [offensivePassive],
  },
  {
    name: 'Bloodthirst',
    tags: [healingPassive],
  },
  {
    name: 'Animosity',
    tags: [resourcePassive],
  },
  {
    name: 'Superstition',
    tags: [defensivePassive, resourcePassive],
  },
  {
    name: 'Tough as Nails',
    tags: [defensivePassive, offensivePassive],
  },
  {
    name: 'No Escape',
    tags: [offensivePassive],
  },
  {
    name: 'Relentless',
    tags: [defensivePassive, resourcePassive, healingPassive],
  },
  {
    name: 'Brawler',
    tags: [offensivePassive],
  },
  {
    name: 'Juggernaut',
    tags: [mobilityPassive, healingPassive],
  },
  {
    name: 'Unforgiving',
    tags: [resourcePassive],
  },
  {
    name: 'Boon of Bul-Kathos',
    tags: [cooldownPassive],
  },
  {
    name: 'Earthen Might',
    tags: [resourcePassive],
  },
  {
    name: 'Sword and Board',
    tags: [defensivePassive, resourcePassive],
  },
  {
    name: 'Rampage',
    tags: [offensivePassive, defensivePassive],
  },
];
